import React from 'react';

import { FlatList } from '@gluestack-ui/themed';

export default function bottomSheetFlatList(props) {
  return <FlatList {...props} />;
}
